export default "__VITE_ASSET__BD5nFSut__"